"use client";

export { capitalize } from "/home/runner/work/ravago-digital-platform/ravago-digital-platform/node_modules/@mui/material/utils/index.js"